import { iSVGprops } from "assets/Icon";

export const Triangle = (props: iSVGprops) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M11.4372 15.443C11.749 15.7516 12.251 15.7516 12.5628 15.443L16.6794 11.3686C17.1874 10.8658 16.8314 10 16.1166 10L7.88336 10C7.16865 10 6.81262 10.8658 7.3206 11.3686L11.4372 15.443Z" 
        fill={props?.color || '#1F1F1F'}
      />
    </svg>
  );
};



